export default `[reanimated-formula]:`;
